import { render, staticRenderFns } from "./event-calendar.vue?vue&type=template&id=3e47b188&scoped=true&"
import script from "./event-calendar.vue?vue&type=script&lang=js&"
export * from "./event-calendar.vue?vue&type=script&lang=js&"
import style0 from "./event-calendar.vue?vue&type=style&index=0&id=3e47b188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47b188",
  null
  
)

export default component.exports